import { render, staticRenderFns } from "./SubTaskMaster.vue?vue&type=template&id=a354227a&scoped=true&"
import script from "./SubTaskMaster.vue?vue&type=script&lang=js&"
export * from "./SubTaskMaster.vue?vue&type=script&lang=js&"
import style0 from "./SubTaskMaster.vue?vue&type=style&index=0&id=a354227a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a354227a",
  null
  
)

export default component.exports